import { Injectable, inject } from '@angular/core'

import type { Observable } from 'rxjs'
import { of } from 'rxjs'
import { catchError, map, shareReplay } from 'rxjs/operators'

import { ApiService } from '../api.service'
import type { ColophonDto, EditorsResponseDto } from '../responses'

@Injectable({
  providedIn: 'root',
})
export class EditorsService {
  private readonly apiService = inject(ApiService)

  private editorsCache$: Observable<EditorsResponseDto> | null = null

  getEditors(): Observable<EditorsResponseDto> {
    this.editorsCache$ ??= this.apiService.getEditors().pipe(
      map(result => result.data),
      shareReplay({ bufferSize: 1, refCount: true })
    )
    return this.editorsCache$
  }

  getEditorialBoard(editionId: number): Observable<ColophonDto[]> {
    return this.apiService.getEditorialBoard(editionId).pipe(
      map(result => {
        const colophon = result.data.Edition.colophon

        return colophon
          .filter(c => c.authors.length > 0)
          .map(c => ({
            ...c,
            authors: c.authors.map(e => ({
              ...e,
              type: 'editor',
            })),
          }))
      }),
      catchError((error: unknown) => {
        console.error(
          `Error fetching editorial board for edition ${String(editionId)}:`,
          error
        )
        return of([] as ColophonDto[])
      })
    )
  }
}
